import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { DoubleOptInPage } from 'pages/settings/pages/doubleOptIn/ui/doubleOptInPage'
import { DoubleOptInLayout } from 'pages/settings/pages/doubleOptIn/layout/DoubleOptInLayout'
import { DoubleOptInAccessLayout } from 'pages/settings/pages/doubleOptIn/layout/DoubleOptInAccessLayout'

export const DoubleOptInRouter = observer(() => {
  return (
    <Routes>
      <Route element={<DoubleOptInAccessLayout />}>
        <Route element={<DoubleOptInLayout />}>
          <Route path={'/'} element={<DoubleOptInPage />} />
        </Route>
      </Route>
    </Routes>
  )
})
